import { analyticsLogger } from './analyticsLogger';

export class AnalyticsError extends Error {
  constructor(
    public service: string,
    public message: string,
    public originalError?: unknown
  ) {
    super(message);
    this.name = 'AnalyticsError';

    // Registrar el error
    analyticsLogger.error(service, message, {
      error: originalError,
      stack: this.stack,
    });
  }
}

export class AnalyticsInitializationError extends AnalyticsError {
  constructor(service: string, message: string, originalError?: unknown) {
    super(service, `Initialization Error: ${message}`, originalError);
    this.name = 'AnalyticsInitializationError';
  }
}

export class AnalyticsTrackingError extends AnalyticsError {
  constructor(service: string, message: string, originalError?: unknown) {
    super(service, `Tracking Error: ${message}`, originalError);
    this.name = 'AnalyticsTrackingError';
  }
}

export class AnalyticsConsentError extends AnalyticsError {
  constructor(service: string, message: string, originalError?: unknown) {
    super(service, `Consent Error: ${message}`, originalError);
    this.name = 'AnalyticsConsentError';
  }
}

export class AnalyticsConfigurationError extends AnalyticsError {
  constructor(service: string, message: string, originalError?: unknown) {
    super(service, `Configuration Error: ${message}`, originalError);
    this.name = 'AnalyticsConfigurationError';
  }
}

// Función auxiliar para manejar errores de inicialización
export const handleInitializationError = (service: string, error: unknown): never => {
  if (error instanceof Error) {
    throw new AnalyticsInitializationError(service, error.message, error);
  }
  throw new AnalyticsInitializationError(service, 'Unknown initialization error', error);
};

// Función auxiliar para manejar errores de tracking
export const handleTrackingError = (service: string, error: unknown): void => {
  if (error instanceof Error) {
    throw new AnalyticsTrackingError(service, error.message, error);
  }
  throw new AnalyticsTrackingError(service, 'Unknown tracking error', error);
};

// Función auxiliar para manejar errores de consentimiento
export const handleConsentError = (service: string, error: unknown): void => {
  if (error instanceof Error) {
    throw new AnalyticsConsentError(service, error.message, error);
  }
  throw new AnalyticsConsentError(service, 'Unknown consent error', error);
};

// Función auxiliar para manejar errores de configuración
export const handleConfigurationError = (service: string, error: unknown): void => {
  if (error instanceof Error) {
    throw new AnalyticsConfigurationError(service, error.message, error);
  }
  throw new AnalyticsConfigurationError(service, 'Unknown configuration error', error);
};
